import type { ReactNode } from 'react';

/** Page title + one-line description on the left, page actions on the right (Figma "Page header"). */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-(--mbm-space-4)">
      <div className="flex flex-col gap-(--mbm-space-1)">
        <h1 className="text-heading-page text-text-strong">{title}</h1>
        {description ? <p className="text-body-compact text-text-secondary">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-(--mbm-space-2)">{actions}</div> : null}
    </header>
  );
}
